module.exports = __webpack_public_path__ + "img/emoticon-nps-4-on.3080fe50.svg";